import { classNames } from '../utils/UNSAFE_classNames';
import { useComponentTheme } from '../hooks/UNSAFE_useComponentTheme';
import { useTabbableMode } from '../hooks/UNSAFE_useTabbableMode';
import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import {
  UserAssistanceStyles,
  UserAssistanceVariantOptions
} from './themes/UserAssistanceStyles.css';
import { UserAssistanceRedwoodTheme } from './themes/redwood/UserAssistanceTheme';

type Props = {
  children?: string;
  source: string;
};

export const InlineHelpSource = ({ children, source }: Props) => {
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const userAssistance_learnMoreStr = translations.userAssistance_learnMore();
  const linkText = children || userAssistance_learnMoreStr;
  // JET-52914 - Implement Tabbable mode API contract in InputText
  // if not tabbable, spread tabbableModeProps on component
  const { isTabbable, tabbableModeProps } = useTabbableMode();
  // TODO: Implement and use a preact Link component instead of using an anchor tag

  const { classes, styles } = useComponentTheme<UserAssistanceVariantOptions, UserAssistanceStyles>(
    UserAssistanceRedwoodTheme
  );

  return (
    <a
      class={classNames([classes, styles.helpSourceStyles])}
      target="_blank"
      href={source}
      {...(!isTabbable && tabbableModeProps)}>
      {linkText}
    </a>
  );
};
